import { ADDLOGINMODE } from '../types/init';
import { INIT_GET_FOLIO_LIST } from '../types/init';

export function addLoginMode(payload) {
    return {
        type: ADDLOGINMODE,
        payload
    }
}

export function getFolioList() {
    return {
        type: INIT_GET_FOLIO_LIST,
    }
}